import {HeaderMall9} from "../../../../publicComponent/Header";
import Navigator from "../../../../publicComponent/h5/Navigator";
import SearchGoodsPageContext, {SearchGoodsPageController, useSearchGoodsPageContext} from "../../../../reducer/moduleReducer/searchGoodsPage";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useQueryParam} from "../../../../hooks";
import Buffer from "../../../../publicComponent/Buffer";
import useUrlState from '@ahooksjs/use-url-state';
import Pagination from "../../../../publicComponent/Pagination";

function SearchGoodsPageWrap() {
  const { getGoodsList, gotoProductDetail, searchSortType } = SearchGoodsPageController();
  const { state } = useSearchGoodsPageContext();
  const [keyword] = useQueryParam('keyword');
  const [searchValue, setSearchValue] = useState(keyword);
  const [, setUrlState] = useUrlState({ keyword });
  const { loading, goodsList, total, query, sortTypes, sortTypeActive } = state;
  const { t } = useTranslation();
  
  const inputHandle = (e) => {
    setSearchValue(e.target.value);
  };
  
  const search = (e) => {
    if (e.keyCode === 13) {
      setUrlState({ keyword: searchValue });
      getGoodsList({ itemName: searchValue });
    }
  };
  
  useEffect(() => {
    getGoodsList({ itemName: keyword });
  }, []);
  
  return (
    <Navigator.container className="container-center pt-[20px]">
      <div className="relative md:mb-[15px] mdmax:p-[8px]">
        <input type="text"
               value={searchValue}
               placeholder={t('输入并搜索')}
               onKeyUp={search}
               onChange={inputHandle}
               className="border-b md:border-[#333] mdmax:border w-[240px] mdmax:w-[100%] py-[8px] px-[12px]"/>
        <i className="iconfont icon-search mdmax:absolute right-[15px] top-[13px]"/>
      </div>
      <div className="flex text-[14px]">
        <p className="mdmax:hidden text-[#999]">{t('搜索结果')}，{t('共为你找到')}{total}{t('款商品')}</p>
        <p className="md:ml-[40px] text-center text-[#999] mdmax:flex">
          {
            sortTypes.map((item, i) => (
              <a className="mx-[18px] mdmax:text-[12px] cursor-pointer mdmax:mx-[5px]"
                 style={{
                   color: i === sortTypeActive ? '#333' : '#999',
                   fontWeight: i === sortTypeActive ? 'bold' : 'normal'
                 }}
                 onClick={() => searchSortType(item.query, i)}
                 key={i}>
                {t(item.name)}
              </a>
            ))
          }
          {/*setSortTypeActive*/}
        </p>
      </div>
      
      <div className="pt-[12px]">
        <Buffer.Loading loading={loading}/>
        {
          goodsList.length > 0
            ? <>
              <div className="relative grid grid-cols-3 md:gap-7
                        mdmax:grid-cols-2 mdmax:gap-4 py-[12px] mdmax:mx-[3%]">
                
                {
                  goodsList.map((item, i) => (
                    <div className="relative inline-block cursor-pointer"
                         onClick={() => gotoProductDetail(item.itemId)}
                         key={i}>
                      <div className="img cursor-pointer mdmax:rounded-[24px] overflow-hidden">
                        <img src={item.mainPicView} className="container"/>
                      </div>
                      <div className="bg-white left-0 text-center
                              py-[12px] px-[20px] mdmax:px-[5px]
                              bottom-[32px] mdmax:bottom-[15px] w-[100%]">
                        <p className="text-lg line-clamp-2 max-h-[50px] cursor-pointer"
                           style={{ lineHeight: '18px' }}>
                          {item.itemName}
                        </p>
                        <p className={'text-2xl mt-[10px] font-bold'}>${item.minPrice}</p>
                      </div>
                    </div>
                  ))
                }
              </div>
              <Pagination total={total}
                          current={query.page}
                          onChange={(page) => getGoodsList({ page })}
                          className="mb-[100px] w-[100%] pr-[50px]"/>
            </>
            : <Buffer.Empty content={t('抱歉！暂时还没有商品')}/>
        }
      
      </div>
    </Navigator.container>
  );
}

export default function SearchGoodsPage() {
  
  return (
    <div className="md:bg-[#f4f4f6]]">
      <HeaderMall9/>
      <Navigator title="搜索商品" goback/>
      <SearchGoodsPageContext>
        <SearchGoodsPageWrap/>
      </SearchGoodsPageContext>
    </div>
  );
}
